(function() {
  var follower, init, mouseX, mouseY, positionElement, timer;

  follower = document.getElementById('circle');
  follower2 = document.getElementById('circle2');

  mouseX = (event) => {
    return event.clientX;
  };

  mouseY = (event) => {
    return event.clientY;
  };

  positionElement = (event) => {
    var mouse;
    mouse = {
      x: mouseX(event)-50,
      y: mouseY(event)-50
    };
    follower.style.top = mouse.y + 'px'
    return follower.style.left = mouse.x + 'px';
  };

  timer = false;

  window.onmousemove = init = (event) => {
    if($(".swiper-button-prev:hover").length != 0 || $(".swiper-button-next:hover").length != 0 || $(".slick-arrow:hover").length != 0 || $(".add-cart-btn.grid-btn .upsell-add:hover").length != 0 || $(".grid-product__meta:hover").length != 0 ){
      $('#circle').css("opacity","0");
    }else{
      if($(".swiper-container:hover").length != 0 || $(".template-index .slick-track:hover").length != 0 || $(".grid.product-grid .product__main-photos-wrapper:hover").length != 0){
        $('#circle').css("opacity","1");
        if($(".swiper-container:hover").length != 0 || $(".template-index .slick-track:hover").length != 0){
           $('#circle span').text('SWIPE');
        }else{
           $('#circle span').text('ZOOM');
        }
      }else{
        $('#circle').css("opacity","0");
      }
    }
    var _event;
    _event = event;
    return timer = setTimeout(() => {
      return positionElement(_event);
    }, 1);
    
  };
  window.onscroll = init = (event) => {
    if($(".swiper-button-prev:hover").length != 0 || $(".swiper-button-next:hover").length != 0 || $(".slick-arrow:hover").length != 0){
      $('#circle').css("opacity","0");
    }else{
      if($(".swiper-container:hover").length != 0 || $(".template-index .slick-track:hover").length != 0 || $(".grid.product-grid .product__main-photos-wrapper:hover").length != 0){
        $('#circle').css("opacity","1");
        if($(".swiper-container:hover").length != 0 || $(".template-index .slick-track:hover").length != 0){
           $('#circle span').text('SWIPE');
        }else{
           $('#circle span').text('ZOOM');
        }
      }else{
        $('#circle').css("opacity","0");
      }
    }
    var _event;
    _event = event;
    return timer = setTimeout(() => {
      return positionElement(_event);
    }, 1);
    
  };

}).call(this);